import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title + ' - RaiseMyFunds';
  }, [title]);
};

export default useDocumentTitle;
